module.exports = __webpack_public_path__ + "static/media/Human.f022b518.png";